import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import Visitor from "../../components/layouts/Visitor";
import HeaderOne from "../../components/parts/HeaderOne";
import AdministratorLoginForm from "../../components/combinations/AdministratorLoginForm";
import { api } from "../../../api";

const LoginStyle = styled.div`
  background: white;
  border-radius: 25px;
  text-align: center;
  padding: 20px 30px;
  margin: 30px;

  @media (max-width: 767px) {
    margin: 30px 10px;
  }
`;

const HeaderOneStyle = styled(HeaderOne)`
  margin-bottom: 20px;
`;

const Login: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    api
      .getAdministratorSession()
      .then((response) => {
        if (response.data) navigate("/administrator/dashboard");
      })
      .catch((error) => {
        Sentry.captureException(error);
      });
  }, []);

  return (
    <Visitor>
      <LoginStyle>
        <HeaderOneStyle>管理者ログイン</HeaderOneStyle>
        <AdministratorLoginForm />
      </LoginStyle>
    </Visitor>
  );
};
export default Login;
